import React from 'react'

const PeopleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#E53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="#E53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="#E53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#E53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="#43A047" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="9 22 9 12 15 12 15 22" stroke="#43A047" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const OPTIONS = [
  {
    key: 'yes',
    icon: <PeopleIcon />,
    iconBg: '#FFEBEE',
    title: 'Yes, it affects others',
    description: 'The issue impacts shared areas or neighbouring units',
  },
  {
    key: 'no',
    icon: <HomeIcon />,
    iconBg: '#E8F5E9',
    title: 'No, only my unit',
    description: 'The issue is limited to my own space',
  },
]

interface AffectsNeighboursStepProps {
  value: string
  onChange: (value: string) => void
}

const AffectsNeighboursStep = ({ value, onChange }: AffectsNeighboursStepProps) => (
  <div>
    <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#0a0d47', margin: '0 0 4px' }}>Does this damage affect other neighbours?</h3>
    <p style={{ fontSize: '0.875rem', color: '#9ca3af', margin: '0 0 24px' }}>Let us know if this issue is limited to your unit or impacts shared areas.</p>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {OPTIONS.map((opt) => {
        const selected = value === opt.key
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '18px 20px',
              borderRadius: '12px',
              border: `1.5px solid ${selected ? '#2196F3' : '#e5e7eb'}`,
              backgroundColor: selected ? '#EFF6FF' : '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              width: '100%',
              transition: 'border-color 0.15s',
            }}
          >
            <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: opt.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {opt.icon}
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: '0 0 2px', fontSize: '0.9375rem', fontWeight: 600, color: '#0a0d47' }}>{opt.title}</p>
              <p style={{ margin: 0, fontSize: '0.8125rem', color: '#9ca3af' }}>{opt.description}</p>
            </div>
            <div style={{
              width: '18px', height: '18px', borderRadius: '50%',
              border: `2px solid ${selected ? '#2196F3' : '#d1d5db'}`,
              backgroundColor: selected ? '#2196F3' : '#fff',
              flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {selected && <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#fff' }} />}
            </div>
          </button>
        )
      })}
    </div>
  </div>
)

export default AffectsNeighboursStep
